import React from 'react';
import PopupCalendar from './../../../common/calendar/PopupCalendar';
import ConstCalendar from './../../../common/calendar/Const';
import { connect } from 'react-redux';
import { changeDate, REDUCER_NAME } from './reducer';
import { isNotLoginOrExpired } from '../../../helpers/Common';
import EventEmitter, { SHOW_GUEST_POPUP } from '../../../helpers/EventEmitter';

const mapStateToProps = state => {
  return {
    startDate: state[REDUCER_NAME].startDate,
    endDate: state[REDUCER_NAME].endDate,
    user: state.userInfo,
  };
};

const mapDispatchToProps = {
  changeDate,
};

function Calendar(props) {
  const onLockClick = () => {
    EventEmitter.dispatch(SHOW_GUEST_POPUP);
  };

  if (isNotLoginOrExpired(props.user)) {
    return (
      <div className="locked-calendar" onClick={onLockClick}>
        <PopupCalendar
          {...props}
          condition={ConstCalendar.COMPARE_CURRENT_DATE}
        />
      </div>
    );
  }

  return (
    <PopupCalendar {...props} condition={ConstCalendar.COMPARE_CURRENT_DATE} />
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Calendar);
